<template>
	<div class="helpPage bg_page_color">
		<mt-header class="header" title="帮助" v-show="type !== 0 ? true : false">
			<router-link to="/help">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button slot="right"></mt-button>
		</mt-header>
		<ul class="catalog margin_header">
			<li v-for="(item,index) in equiData.rows">
				<div class="title">
					<div class="label-icon">
						<img ref="images" :src="images.label" />
					</div>
					<span>{{item.title}}</span>
				</div>
				<ul class="subdirectory">
					<li @click="toUrl(val.type,val.id,val.linkUrl,val.title)" v-for="val in item.children">
						<span>{{val.title}}</span>
					</li>
					<li v-for="val in item.children" v-if="item.children.length == 1 ? true : false">
						<span></span>
					</li>
				</ul>
			</li>
			<!--<div class="currentEqui" v-show="equiData.isMatch == 0 ? false:true" v-on:click="toEquiHome()">
				<div class="equi-icon">
					<img :src="equiData.image"/>
				</div>
				<h6>{{equiData.title}}equiData.title</h6>
			</div>-->
		</ul>

		<!--<a target="_blank" href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzkzODAzMjA2Ml80ODI0ODlfNDAwNjc1NDMwMF8yXw" class="concatUs" @click="clickQQ()" v-show="equiData.isMatch !== 1">
			<div class="qq_icon">
				<img :src="images.qq" />
			</div>
			<span class="text">联系我们</span>
			<span class="time">（工作日 9：00——23：30）</span>
		</a>-->

		<div class="bottom-link" v-show="equiData.isMatch == 1">
			<a target="_blank" href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzkzODAzMjA2Ml80ODI0ODlfNDAwNjc1NDMwMF8yXw" @click="clickQQ()" class="link">
				<span>联系我们</span>
			</a>
			<div class="currentEqui" v-show="equiData.isMatch == 0 ? false:true" v-on:click="toEquiHome()">
				<div class="equi-icon">
					<img :src="equiData.image" />
				</div>
				<h6>{{equiData.title}}</h6>
			</div>
		</div>
	</div>
</template>

<script>
	import { Indicator, MessageBox } from 'mint-ui';
	import { get } from 'assets/api/config'

	var img = {};
	img.label = require('../../assets/images/faq/label.png');
	img.qq = require('../../assets/images/faq/QQ.png');

	export default {
		data() {
			return {
				images: img,
				equiData: '', //数据
				//rows: [],
				type: '', //打开方式默认（0）为客户端\n
				handle: '', //当前检测到的手柄型号
				isMatch: 1 //是否匹配手柄
			}
		},
		mounted: function() {
			var that = this;
			//进入的首页
			//loading
			Indicator.open({
				spinnerType: 'fading-circle'
			});
//
			let handle = this.$route.query.handle;
			this.handle = handle;
//
			let data = {
				token: handle + '||0',
				act: 'faqIndex'
			}

			get(data).then(function(res) {
				//关闭loading
				Indicator.close();
				if(res.msg !== '成功') {
					MessageBox.alert('获取数据失败').then(action => {
						return;
					});
				}
				let rows = res.data.rows;
				for(let x in rows) {
					let currentLength = rows[x].children.length;
					if(currentLength % 2 == 1) {
						rows[x].children.push({})
					}
				}
				res.data.rows = rows;
				that.equiData = res.data;
			});
//
			if(window.JsOperation != undefined) {
				//anzhuo
				this.type = 0;
			}

		},
		methods: {
			toUrl(type, id, href, title) {
				let that = this;
				/*
				 * type：跳转类型
				 * id：id
				 * href：跳转链接
				 * title：跳转标题
				 * */

				//localStorage.setItem('title', title);
				if(typeof id !== "undefined") {
					if(type == '1') {
						//目录
						//					var isMatch = this.equiData['isMatch'];
						let token = id + '||' + this.handle + '||0'
						this.$router.push({name:'equipment',params:{id:token}})

					} else if(type == '2') {
						//外链
						if(window.JsOperation) {
							this.count(id,function(){
								location.href = href;
							});
						}else{
							location.href = href;
						}
					} else {
						//正文
						if(window.JsOperation) {
							this.count(id,function(){
								that.$router.push({name:'content',params:{id:id}})
							});
						}else{
							this.$router.push({name:'content',params:{id:id}})
						}
					}
				}

			},
			count(faqId,callback){
				//统计
				/*
				 * deviceId：从安卓中获取的设备id
				 * faqId：FAQ-ID
				 * token deviceId||faqId
				 * */

				let deviceId = "";
				//安卓情况下
				if(window.JsOperation){
					deviceId = window.JsOperation.getDeviceId();
				}

				let data = {
					token: deviceId + '||' + faqId,
					act: 'faqClick'
				}

				get(data).then(function(res) {
					callback(res)
				});
			},
			clickQQ(e) {
				if(window.JsOperation) {
					//安卓情况下
					if(e && e.preventDefault) {
						e.preventDefault();
					} else {
						window.event.returnValue = false; //兼容IE
					}
					window.JsOperation.clickQQ()
				}

			},
			toEquiHome() {
				let token = this.handle + '||1';
				this.$router.push({
					path: '/equi_home',
					query: {
						handle: token
					}
				});
			}
		}

	}
</script>

<style lang="less" scoped>
	.helpPage{
		background-color: #f6f6f6;
	}

	.header {
		background-color: #ce3d3e !important;
		z-index: 999;
		height: 120px !important;

		.mint-header-title {
			font-size: 40px !important;
		}
		.mintui {
			font-size: 40px !important;
		}
	}

	.page_padding {
		padding-bottom: 170px;
	}

	.catalog {
		position: relative;
		/*padding-bottom: 146px;*/
		border-bottom: 1px solid #F6F6F6;
		.title {
			position: relative;
			padding: 0 46px;
			height: 180px;
			line-height: 180px;
			color: #333333;
			font-size: 40px;
			text-align: left;
			.label-icon {
				position: absolute;
				display: flex;
				top: 63px;
				width: 32px;
				height: 46px;
				text-align: center;
				img {
					display: inline-block;
					width: 100%;
					height: 100%;
				}
			}
			span {
				margin-left: 58px;
			}
		}
		&>li {
			margin-bottom: 26px;
			background-color: #FFFFFF;
		}
		&>li:last-child {
			margin-bottom: 0 !important;
		}
		.subdirectory {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			text-align: left;
			border-top: 1px solid #F6F6F6;
			overflow: hidden;
			background-color: #f6f6f6;
			li {
				display: inline-block;
				/*padding: 0 46px;*/
				/*width: calc(50vw - 98px);*/
				width: calc(50vw - 0.5px);
				height: 150px;
				line-height: 156px;
				color: #666666;
				font-size: 40px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				background-color: #fff;
				margin-bottom: 1px;
				&>span {
					display: block;
					padding: 0 46px;
					/*height: 150px;
					line-height: 150px;*/
				}
			}
			/*li:first-child{
				border-bottom: 1px solid #F6F6F6;
			}

			li:nth-child(2){
				border-bottom: 1px solid #F6F6F6;
			}*/
			li:nth-child(2n-1) {
				border-right: 1px solid #F6F6F6;
			}
		}
		/*型号设备*/
		/*.currentEqui{
			position: absolute;
			display: flex;
			justify-content: space-between;
			padding: 0 30px 0 20px;
			align-items: center;
			right: 0;
			top: 60px;
			min-width: 200px;
			height: 70px;
			border: 1px solid #f2f2f2;
			border-top-left-radius:20px;
			border-bottom-left-radius:20px;

			.equi-icon{
				width: 50px;
				height: 50px;
				margin-right: 20px;

				img{
					width: 100%;
					height: 100%;
				}
			}
		}*/
	}

	.concatUs {
		position: fixed;
		bottom: 0;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 146px;
		line-height: 146px;
		text-align: center;
		background-color: #FFFFFF;
		border-top: 1px solid #F6F6F6;
		text-decoration: none;
		.qq_icon {
			display: flex;
			width: 89px;
			height: 89px;
			margin-right: 25px;
			img {
				display: inline-block;
				vertical-align: middle;
				width: 100%;
				height: 100%;
			}
		}
		.text {
			height: 100%;
			font-size: 40px;
			line-height: 160px;
			color: #333333;
		}
		.time {
			height: 100%;
			font-size: 36px;
			line-height: 158px;
			color: #999999;
		}
	}
	/*匹配到手柄的*/
	.bottom-link {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 146px;
		line-height: 146px;
		display: flex;
		background-color: #FFFFFF;
		border-top: 1px solid #F6F6F6;
		font-size: 40px;
		.link {
			display: block;
			width: 50%;
			border-right: 3px #f6f6f6 solid;
			text-decoration: none;
			color: #333333;
			span {
				display: block;
				width: 100%;
			}
		}
		.currentEqui {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 50%;
			.equi-icon {
				width: 110px;
				margin-right: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 100%;
				}
			}
			h6 {
				color: #333333;
			}
		}
	}

  @media screen and (min-width: 700px) {
    .helpPage {
      background-color: #f7f7f7;
      height: 100%;
      .header {
        margin: 0 auto;
        height: 66PX !important;
        width: 668PX;
        font-size: 24PX !important;
      }
      /deep/.header .mint-header-title, .header .mintui {
        font-size: 24PX !important;
      }
      .catalog {
        width: 668PX;
        margin: 0 auto;
        >li {
          margin-bottom: 20PX;
          &:last-child {
            margin-bottom: 20PX !important;
          }
          .title {
            height: 70PX;
            line-height: 70PX;
            font-size: 24PX;
            .label-icon {
              height: 22PX;
              width: 15PX;
              top: 23PX;
            }
            span {
              margin-left: 30PX;
              font-size: 20PX;
            }
          }
          .subdirectory {
            >li {
              width: 332PX;
              font-size: 18PX;
              line-height: 60PX;
              height: 60PX;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/FAQ/help.vue